import isServer from '@hydra/utils/isServer';

export function sendGaEvent (category, action, label) {
  if (!isServer()) {
    window.ga && window.ga('send', 'event', category, action, label);
  }
}
